<template>
  <div class="manage-driver-panel">
    <div class="wrapper">
      <section v-if="driver">
        <p class="header">
          Manage Driver
          <button class="delete is-large is-pulled-right" @click="close" />
        </p>
        <p v-if="!otherDriver" class="has-text-link">You are the Driver</p>
        <p v-if="!isWorking" class="has-text-danger">
          Driver is not working now
        </p>

        <div class="media">
          <div class="media-left">
            <figure class="image">
              <img :src="driverPic" />
            </figure>
          </div>
          <div class="media-content">
            <p>
              <i class="fa fa-user" />
              <span class="has-text-weight-medium">{{ driver.name }}</span>
            </p>
            <p>
              <i class="far fa-clock" />
              <span>{{ locationAt }}</span>
            </p>
          </div>
        </div>
        <div class="is-flex" style="margin-top: 10px">
          <a class="button is-medium" @click="callDriver">
            <i class="fa fa-phone fa-lg" /> </a
          >&nbsp;
          <a class="button is-medium" @click="chat">
            <i class="fa fa-comments fa-lg" />
          </a>
        </div>

        <div v-if="drivers" class="control has-icons-left is-expanded">
          <div class="select is-success is-fullwidth is-medium">
            <select @change="selectDriver($event)" id="manage-driver-select">
              <option disabled selected value>
                -- {{ $t("driver.change-driver") }} --
              </option>
              <option v-for="d in drivers" :value="d.value" :key="d.key">
                {{ d.key }}
              </option>
            </select>
            <span class="icon is-small is-left">
              <i class="fas fa-shuttle-van" />
            </span>
          </div>
        </div>
        <div
          v-else
          class="notification is-danger"
          style="margin-top: 9px; padding: 6px"
          @click="copyWorkflowID"
        >
          <i>No drivers for workflow </i>
          <span class="tag">{{ shortenString(t.workflow_id, 5) }}</span>
        </div>
        <div v-if="changeDriver" style="margin-top: 10px">
          <span
            class="button is-success is-fullwidth is-medium pulse-btn"
            @click="patchTransaction"
            >{{ $t("driver.change-driver") }}&nbsp;<i
              class="fa fa-chevron-right"
          /></span>
        </div>
        <div style="height: 30px" />
      </section>
      <section v-else @click="close">
        <p style="font-size: 1.2em; padding: 10px">Fetching driver data</p>
        <p style="padding: 20px; text-align: center">
          <i class="fa fa-atom fa-spin fa-8x has-text-grey" />
        </p>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: "ManageDriverPanel",
  props: {
    transaction: Object,
  },
  data() {
    return {
      dispatchTo: null, // driver to dispatch to
      driver: null, // pull current driver data from DB
      drivers: [], // all drivers for workflow
    };
  },
  computed: {
    t() {
      return this.transaction;
    },
    // drivers() {
    //   if (this.$store.state.workflowDrivers) {
    //     return this.$store.state.workflowDrivers;
    //   }
    //   return [];
    // },
    changeDriver() {
      if (this.dispatchTo) return true;
      return false;
    },
    driverPic() {
      if (!this.driver) return null;
      return this.driver.profile_pic_url || this.$store.state.birdProfilePic;
    },
    locationAt() {
      var ts = this.driver.user_state.updated_at;
      var mins = (new Date() - new Date(ts)) / (1000 * 60);
      return `${Math.round(mins)} mins ago`;
    },
    isWorking() {
      if (!this.driver.role) return false;
      return this.driver.role.state === "working";
    },
    otherDriver() {
      return this.t.handled_by !== this.userID();
    },
  },
  mounted() {
    // this.updateDriversAutocomplete();
    this.getRideOrder();
    this.getDrivers();
  },
  methods: {
    close() {
      this.$emit("update");
      this.$emit("close");
    },
    copyWorkflowID() {
      this.infoToast("Copied Workflow ID");
      this.$copyText(this.t.workflow_id);
    },
    getRideOrder() {
      this.driver = null;
      this.$store
        .dispatch("getRideOrder", this.t.id)
        .then((res) => (this.driver = res.data.driver))
        .catch((err) => this.apiError(err));
    },
    selectDriver(e) {
      this.dispatchTo = e.target.value;
    },
    callDriver() {
      var mobile = this.driver.phone_number;
      window.location.href = `tel:${mobile}`;
    },
    chat() {
      this.$swal({
        html: `<p style='text-align:left'>
        <i class='far fa-comment'></i>&nbsp;Send message to driver 
        </p>`,
        input: "text",
        confirmButtonText: this.$t("send"),
        cancelButtonText: this.$t("cancel"),
        showCancelButton: true,
      }).then((val) => {
        if (val.value) this.sendMessage(val.value, "push", this.driver.id);
      });
    },
    // move to shared func
    sendMessage(msg, type, userID) {
      var loader = this.loadingDots("orange");
      this.$store
        .dispatch("sendMessageToUser", {
          user_id: userID,
          message: msg,
          type: type, // send type: sms or push
        })
        .then(() => this.infoToast("Message has been sent 🙏🏼", "top"))
        .catch((err) => this.apiError(err))
        .finally(() => loader.hide());
    },
    updateDriversAutocomplete() {
      this.$store
        .dispatch("autocompleteDriverWorkflows", this.t.workflow_id)
        .then((res) => {
          console.log("autocompleteDriverWorkflows", res);
        })
        .catch((err) => this.apiError(err));
    },
    getDrivers() {
      this.$store
        .dispatch("getDriversForWorkflow", this.t.workflow_id)
        .then((res) => {
          console.log("getDrivers", res.data);
          this.drivers = res.data || [];
        })
        .catch((err) => this.apiError(err));
    },
    patchTransaction() {
      var loader = this.loadingDots();
      this.$store
        .dispatch("patchTransaction", {
          transactionID: this.transaction.id,
          data: {
            // state: "confirmed",
            handled_by: this.dispatchTo,
            data: { acknowledged: false },
          },
        })
        .then(() => this.updateTransactionsForDriver(true))
        .catch((err) => this.apiError(err))
        .finally(() => {
          loader.hide();
          this.close();
        });
    },
  },
};
</script>

<style scoped>
.manage-driver-panel {
  position: absolute;
  bottom: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  background-color: rgba(0, 0, 0, 0.4);
  text-align: left;
}
.wrapper {
  position: absolute;
  bottom: 0;
  width: 100vw;
  padding: 10px;
  background-color: white;
}
.header {
  font-size: 1.3em;
  font-weight: 450;
  margin-bottom: 4px;
}
img {
  /* border-radius: 8px;
  border: 2px solid gold;
  height: 80px;
  width: auto; */
  object-fit: cover;
  height: 80px;
  width: 80px;
  border-radius: 3px;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.14);
  background-color: white;
}
.card-content {
  padding: 6px;
  overflow: hidden !important;
}
.tag {
  padding: 0 6px;
}
.media {
  margin-top: 10px;
}
.media-left {
  margin-right: 0px;
}
.media-content i {
  color: grey;
  display: inline-block;
  width: 30px;
  text-align: center;
}
.media-content p {
  padding-top: 6px;
}
.is-flex .button {
  flex: 1;
  color: var(--link);
}
.control {
  margin-top: 10px;
}
.pulse-btn {
  animation: shadow-pulse-gold 2s ease-out infinite;
  border-radius: 3px;
}
@keyframes shadow-pulse-gold {
  0% {
    box-shadow: inset 0 0 0 0px rgba(255, 255, 0, 1);
  }
  50% {
    box-shadow: inset 0 0 0 6px rgba(255, 255, 0, 0.7);
  }
  100% {
    box-shadow: inset 0 0 0 0px rgba(255, 255, 0, 1);
  }
}
</style>